import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { formatKilos, formatPercent } from '../../utils/flujoCalculations';

const CalculationRow = ({ label, value, suffix }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: 2,
      py: 0.75,
      borderBottom: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Typography sx={{ color: 'text.secondary', fontSize: 14, fontWeight: 700 }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: 16, fontWeight: 900, textAlign: 'right' }}>
      {value} {suffix}
    </Typography>
  </Box>
);

const CalculationBlock = ({ title, children }) => (
  <Box
    sx={{
      p: 2,
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 2,
      bgcolor: 'background.paper',
      height: '100%',
    }}
  >
    <Typography sx={{ color: 'primary.main', fontSize: 16, fontWeight: 900, mb: 1 }}>
      {title}
    </Typography>
    {children}
  </Box>
);

export const EntradaCalculationDialog = ({ open, onClose, totals }) => {
  const detalle = totals?.detalle || {};
  const percentages = totals?.percentages || {};

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          fontWeight: 900,
        }}
      >
        Detalle de calculos
        <IconButton aria-label="Cerrar" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ bgcolor: 'background.default' }}>
        <Stack spacing={2}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <CalculationBlock title="Resumen Access">
                <CalculationRow label="Kg volcados" value={formatKilos(totals.kilosVolcados)} suffix="kg" />
                <CalculationRow label="Kg reales" value={formatKilos(totals.kgReales)} suffix="kg" />
                <CalculationRow label="Kg primera" value={formatKilos(totals.kilosPrimera)} suffix="kg" />
                <CalculationRow label="Peso palot merma" value={formatKilos(totals.pesoPalotMerma)} suffix="kg" />
              </CalculationBlock>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <CalculationBlock title="Porcentajes">
                <CalculationRow label="Retorno" value={formatPercent(percentages.retorno)} suffix="%" />
                <CalculationRow label="Otros calibres" value={formatPercent(percentages.otrosCalibres)} suffix="%" />
                <CalculationRow label="Verde" value={formatPercent(percentages.verde)} suffix="%" />
                <CalculationRow label="Primera" value={formatPercent(percentages.primera)} suffix="%" />
              </CalculationBlock>
            </Grid>
          </Grid>

          <CalculationBlock title="Clasificacion y mermas">
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <CalculationRow label="Retorno" value={formatKilos(detalle.retornoKg)} suffix="kg" />
                <CalculationRow label="Precalibrado" value={formatKilos(detalle.otrosCalibresKg)} suffix="kg" />
                <CalculationRow label="Verde" value={formatKilos(detalle.verdeKg)} suffix="kg" />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <CalculationRow label="Segunda" value={formatKilos(detalle.segundaKg)} suffix="kg" />
                <CalculationRow label="Bajo calibre" value={formatKilos(detalle.bajoCalibreKg)} suffix="kg" />
                <CalculationRow label="Industria" value={formatKilos(detalle.industriaKg)} suffix="kg" />
                <CalculationRow label="Podrido" value={formatKilos(detalle.podridoKg)} suffix="kg" />
              </Grid>
            </Grid>
          </CalculationBlock>

          <Divider />

          <Typography sx={{ color: 'text.secondary', fontSize: 13, fontWeight: 700 }}>
            Kg reales descuenta retorno, verde y precalibrado desde Kg volcados. Primera se calcula como
            100 menos segunda, podrido, bajo calibre e industria sobre Kg reales.
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
